import { useGetAllGlowUpProducts } from '@/api/glow-up-product/glow-up-product.hooks';
import { ErrorScreen } from '@/components/ui/error-screen';
import { LoadingScreen } from '@/components/ui/loading-screen';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Category } from '@repo/types/src/glow-up';
import { useState } from 'react';
import { AddGlowUpProduct } from './AddGlowUpProduct';
import { GlowUpProductList } from './GlowUpProductList';

interface Props {
  categories: Category[];
}

export const GlowUpProductManagement = ({ categories }: Props) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<number>(
    categories[0]?.id ?? 0,
  );

  const { products, isLoading, isError } = useGetAllGlowUpProducts();

  if (isLoading) return <LoadingScreen />;
  if (isError) return <ErrorScreen />;

  const filteredProducts =
    selectedCategoryId > 0
      ? products.filter((p) => p.categoryId === selectedCategoryId)
      : products;

  const selectedCategory = categories.find((c) => c.id === selectedCategoryId);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-1">
          <h2 className="text-2xl font-semibold">Produits Glow Up</h2>
          <p className="text-sm text-zinc-500">
            Produits affichés sous les catégories dans l'application
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Select
            value={String(selectedCategoryId)}
            onValueChange={(val) => setSelectedCategoryId(Number(val))}
          >
            <SelectTrigger className="w-56">
              <SelectValue placeholder="Choisir une catégorie" />
            </SelectTrigger>
            <SelectContent>
              {categories.map((category) => (
                <SelectItem key={category.id} value={String(category.id)}>
                  {category.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {selectedCategoryId > 0 && (
            <AddGlowUpProduct categoryId={selectedCategoryId} />
          )}
        </div>
      </div>

      {selectedCategory && (
        <p className="text-sm text-zinc-600">
          Catégorie sélectionnée :{' '}
          <span className="font-medium">{selectedCategory.title}</span>
        </p>
      )}

      <GlowUpProductList products={filteredProducts} />
    </div>
  );
};
